export const ADD_TO_FAVOURITES = 'ADD_TO_FAVOURITES'
export const REMOVE_FROM_FAVOURITES = 'REMOVE_FROM_FAVOURITES'
export const FILTER_BY = 'FILTER_BY'
export const FETCH_GAMES = ['GAMES_REQUEST', 'GAMES_SUCCESS', 'GAMES_FAILURE']



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js